import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { WeekPlanTotals } from '../../core/types/weekPlan';

interface CarsSummaryTableProps {
  totals: WeekPlanTotals[];
}

export const CarsSummaryTable = ({ totals }: CarsSummaryTableProps) => {
  const carsColumns: GridColDef[] = [
    {
      field: 'mondayCars',
      headerName: 'Man',
      flex: 1,
      sortable: false,
      valueFormatter: (params) => (params.value ? +params.value.toFixed(1) : '0'),
      type: 'number',
    },
    {
      field: 'tuesdayCars',
      headerName: 'Tir',
      flex: 1,
      sortable: false,
      valueFormatter: (params) => (params.value ? +params.value.toFixed(1) : '0'),
      type: 'number',
    },
    {
      field: 'wednesdayCars',
      headerName: 'Ons',
      flex: 1,
      sortable: false,
      valueFormatter: (params) => (params.value ? +params.value.toFixed(1) : '0'),
      type: 'number',
    },
    {
      field: 'thursdayCars',
      headerName: 'Tor',
      flex: 1,
      sortable: false,
      valueFormatter: (params) => (params.value ? +params.value.toFixed(1) : '0'),
      type: 'number',
    },
    {
      field: 'fridayCars',
      headerName: 'Fre',
      flex: 1,
      sortable: false,
      valueFormatter: (params) => (params.value ? +params.value.toFixed(1) : '0'),
      type: 'number',
    },
  ];

  if (!totals) return null;

  return (
    <DataGrid
      rows={totals}
      columns={carsColumns}
      getRowId={(row) => row.mondayCars}
      autoHeight
      disableColumnMenu
      hideFooter
      sx={{
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bold',
        },
      }}
    />
  );
};
